
// src/connects/group-nav.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import actions from '../actions'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state, ownProps)=> {
  return {}
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  const params = {
    group_id: ownProps.group.group_id,
    group: ownProps.group
  }

  return {
    openReportStatusPage: ()=> dispatch(actions.openRightSidePage('report_status', params)),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: { searchDrawer: false }}),
  translate(),
  lifecycle,
)



// WEBPACK FOOTER //
// ./src/connects/diary-report-active-user-bar.js